import { Box, SimpleGrid, Image, Text, HStack } from "@chakra-ui/react";
import { FaAward } from "react-icons/fa";
import { useLanguage } from "../context/LanguageContext";
import { useCertifications, pick } from "../hooks/useContent";
import { CertSkeleton } from "./ui/Skeletons";
import Section from "./ui/Section";

function Certifications() {
  const { language } = useLanguage();
  const { data: certs = [], loading } = useCertifications();

  if (loading) {
    return (
      <Section
        id="certifications"
        eyebrow={language === "es" ? "FORMACIÓN" : "CERTIFICATIONS"}
        title={language === "es" ? "Certificados y cursos" : "Certificates & courses"}
      >
        <CertSkeleton count={6} />
      </Section>
    );
  }
  if (!certs.length) return null;

  return (
    <Section
      id="certifications"
      eyebrow={language === "es" ? "FORMACIÓN" : "CERTIFICATIONS"}
      title={language === "es" ? "Certificados y cursos" : "Certificates & courses"}
    >
      <SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} spacing={4}>
        {certs.map((c) => (
          <HStack
            key={c.id}
            bg="bg.card"
            border="1px solid"
            borderColor="border.card"
            borderRadius="xl"
            p={4}
            spacing={4}
            align="center"
          >
            {c.image_url ? (
              <Image
                src={c.image_url}
                alt={pick("name", c, language)}
                boxSize="48px"
                objectFit="contain"
                borderRadius="md"
                bg="white"
                p={1}
                flexShrink={0}
              />
            ) : (
              <Box
                boxSize="48px"
                borderRadius="md"
                bg="blue.600"
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexShrink={0}
              >
                <FaAward color="white" size={22} />
              </Box>
            )}
            <Box>
              <Text color="text.heading" fontWeight="bold" fontSize="sm">
                {pick("name", c, language)}
              </Text>
              <Text color="text.muted" fontSize="xs">
                {c.issuer}
              </Text>
            </Box>
          </HStack>
        ))}
      </SimpleGrid>
    </Section>
  );
}

export default Certifications;
